import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllFeedbackSubmissions } from '../lib/feedback';

const OWNER_USER_ID = 'b21edb91-cbd9-496c-8674-9935f030cfcb';

function AdminFeedbackPage({ session, theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isOwner = session?.user?.id === OWNER_USER_ID;

  useEffect(() => {
    let mounted = true;

    async function loadFeedback() {
      if (!isOwner) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');
        const rows = await fetchAllFeedbackSubmissions();
        if (!mounted) return;
        setSubmissions(rows);
      } catch (err) {
        console.error(err);
        if (mounted) {
          setError(err.message || 'Failed to load feedback.');
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadFeedback();

    return () => {
      mounted = false;
    };
  }, [isOwner]);

  if (!isOwner) {
    return (
      <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
        <div className="legal-page-container">
          <div className="legal-page-card">
            <h1 className="legal-page-title">Access Denied</h1>
            <p className="legal-page-updated">
              This page is restricted.
            </p>
            <button
              type="button"
              className="desktop-secondary-btn"
              onClick={() => navigate('/')}
            >
              Back to App
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container feedback-admin-container">
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card">
          <div className="legal-page-badge">Admin</div>
          <h1 className="legal-page-title">Feedback Review</h1>
          <p className="legal-page-updated">
            Review user feedback submissions.
          </p>

          {error ? <div className="journal-error-banner">{error}</div> : null}

          {loading ? (
            <p className="performance-empty-copy">Loading feedback...</p>
          ) : submissions.length === 0 ? (
            <p className="performance-empty-copy">No feedback submitted yet.</p>
          ) : (
            <div className="feedback-admin-list">
              {submissions.map((item) => (
                <div key={item.id} className="feedback-admin-card">
                  <div className="feedback-admin-meta">
                    <span>User: {item.user_id}</span>
                    <span>{new Date(item.created_at).toLocaleString()}</span>
                  </div>

                  <div className="feedback-admin-section">
                    <h3>What confused you?</h3>
                    <p>{item.confused_text || '—'}</p>
                  </div>

                  <div className="feedback-admin-section">
                    <h3>What felt useful?</h3>
                    <p>{item.useful_text || '—'}</p>
                  </div>

                  <div className="feedback-admin-section">
                    <h3>What feature would make this more valuable?</h3>
                    <p>{item.valuable_feature_text || '—'}</p>
                  </div>

                  <div className="feedback-admin-section">
                    <h3>Did anything break?</h3>
                    <p>{item.breakage_text || '—'}</p>
                  </div>

                  <div className="feedback-admin-section">
                    <h3>Would you pay for this? Why or why not?</h3>
                    <p>{item.pay_text || '—'}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminFeedbackPage;